/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import classNames from 'classnames';

import createLoadableComponent from 'js/lib/createLoadableComponent';

import SimplifiedMegaMenuWrapper from 'bundles/megamenu/components/SimplifiedMegaMenuWrapper';
import { shouldShowNewMegamenu } from 'bundles/megamenu/utils/experimentUtils';
import MegaMenuWrapper from 'bundles/page-header/components/desktop/mega-menu/MegaMenuWrapperLite';
import LazyLoadingHandler from 'bundles/page/components/shared/LazyLoadingHandler';
import SearchBar from 'bundles/search-common/components/searchbar/SearchBar';

import 'css!bundles/page-header/components/desktop/__styles__/BrowseContentWrapper';

const LoadableMegaMenu = createLoadableComponent(
  () => import('bundles/page-header/components/optimized/MegaMenuContent'),
  LazyLoadingHandler
);

type Props = {
  className?: string;
  isFrontPage?: boolean;
  shouldShowCourseraPlusButton?: boolean;
};

type State = {
  searchInputIsFocused: boolean;
};

const styles = {
  wrapper: css`
    display: flex;
    align-items: center;
  `,
};

class BrowseContentWrapper extends React.Component<Props, State> {
  state = { searchInputIsFocused: false };

  onFocus = () => {
    this.setState({ searchInputIsFocused: true });
  };

  onBlur = () => {
    this.setState({ searchInputIsFocused: false });
  };

  render() {
    const { className: customClassName, isFrontPage, shouldShowCourseraPlusButton } = this.props;
    const { searchInputIsFocused } = this.state;

    return (
      <div
        className={classNames('browse-content-wrapper horizontal-box', {
          [`${customClassName}`]: customClassName !== undefined,
        })}
      >
        <div className="MegamenuWrapperDiv" key="MegamenuWrapperDiv" id="MegamenuWrapperDiv" css={styles.wrapper}>
          {/* adding wrapper to fix GR-24338 */}
          {shouldShowNewMegamenu() ? (
            <SimplifiedMegaMenuWrapper shouldShowCourseraPlusButton={shouldShowCourseraPlusButton} />
          ) : (
            <MegaMenuWrapper
              renderMenuOnServer={isFrontPage}
              key="MegamenuWrapper"
              LoadableMegaMenu={LoadableMegaMenu}
            />
          )}
        </div>
        <SearchBar
          key="SearchBar"
          isSearchPage={false}
          searchInputIsFocused={searchInputIsFocused}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          {...this.props}
        />
      </div>
    );
  }
}
export default BrowseContentWrapper;
